import pkg from '../package.json';
import ArchiveView from './views/archive';
import TermView from './views/term';
import DateView from './views/date';
import FilterView from './views/filter';
import Predictive from './views/predictive';
import SelectEdition from './views/select-edition';

const {$} = Voonto;

Voonto.ready.then((app) => {
  $('[data-voc-krammer-archive]').each(function() {new ArchiveView($(this));});
  $('[data-voc-krammer-term]').each(function() {new TermView($(this));});
  $('[data-voc-krammer-date]').each(function() {new DateView($(this));});
  $('[data-voc-krammer-filter]').each(function() {new FilterView($(this));});
  $('[data-voc-krammer-predictive]').each(function() {new Predictive($(this), {serviceUrl: app.lookup('vocento.config.krammer.predictiveUrl')});});
  $('[data-voc-krammer-select-edition]').each(function() {new SelectEdition($(this));});
});

export const VERSION = pkg.version;



// WEBPACK FOOTER //
// ./src/index.js